import Vue from 'vue'
import VuePageTitle from 'vue-page-title'
import App from './App.vue'
import router from './router'
import store from './store'
import NProgress from 'vue-nprogress'
// import FirebaseAuthService from './services/firebase'
import { i18n } from '@/localization'
import VueLayers from 'vuelayers'
import BootstrapVue from 'bootstrap-vue'
import ApiService from './plugins/api'
import InstagramImageService from './plugins/instagram-image'
import Notification from './plugins/notification'
import Message from './plugins/message'
import Confirm from './plugins/confirm'
import VueChartist from 'v-chartist'
import VueApexCharts from 'vue-apexcharts'
import VSwatches from 'vue-swatches'
import VueCalendarHeatmap from 'vue-calendar-heatmap'

import { InlineSvgPlugin } from 'vue-inline-svg'

import {
	Statistic,
	Descriptions,
	PageHeader,
	Comment,
	Empty,
	Avatar,
	TreeSelect,
	Rate,
	Breadcrumb,
	InputNumber,
	Steps,
	Upload,
	Button,
	Layout,
	Table,
	Icon,
	Progress,
	Radio,
	Dropdown,
	Menu,
	Carousel,
	Input,
	Calendar,
	Badge,
	Slider,
	Form,
	Tooltip,
	Select,
	Switch,
	Tag,
	Affix,
	Spin,
	Alert,
	Checkbox,
	Tabs,
	Pagination,
	Drawer,
	Cascader,
	DatePicker,
	TimePicker,
	Divider,
	Anchor,
	AutoComplete,
	BackTop,
	Collapse,
	Card,
	List,
	Popover,
	Tree,
	Timeline,
	Row,
	Col,
	Transfer,
	Modal,
	Popconfirm,
	Skeleton,
	ConfigProvider,
} from 'ant-design-vue'

import './global.scss'

import * as VueMoment from 'vue-moment'

import VueLazyload from 'vue-lazyload'
import VuePlyr from 'vue-plyr'

Vue.use(VuePlyr, {
	plyr: {
		fullscreen: { enabled: false },
	},
	emit: ['ended'],
})

Vue.use(InlineSvgPlugin)

Vue.use(VueLazyload, {
	preLoad: 1.3,
	error: 'resources/images/not_found.png',
	loading: 'resources/images/loading.gif',
})

Vue.component('apexchart', VueApexCharts)
Vue.component('v-swatches', VSwatches)
import VueKonva from 'vue-konva'

Vue.use(VueKonva)
Vue.use(VueChartist)
Vue.use(Empty)
Vue.use(VueMoment)
Vue.use(Confirm)
Vue.use(Notification)
Vue.use(BootstrapVue)
Vue.use(VueLayers)
Vue.use(ApiService)
Vue.use(InstagramImageService)
Vue.use(Skeleton)
Vue.use(Avatar)
Vue.use(Popconfirm)
Vue.use(Transfer)
Vue.use(Statistic)
Vue.use(Modal)
Vue.use(Divider)
Vue.use(Row)
Vue.use(Col)
Vue.use(Timeline)
Vue.use(Tree)
Vue.use(Popover)
Vue.use(List)
Vue.use(Card)
Vue.use(Button)
Vue.use(Rate)
Vue.use(TreeSelect)
Vue.use(Breadcrumb)
Vue.use(Layout)
Vue.use(Table)
Vue.use(Icon)
Vue.use(Progress)
Vue.use(Radio)
Vue.use(Dropdown)
Vue.use(Menu)
Vue.use(Carousel)
Vue.use(Input)
Vue.use(Calendar)
Vue.use(Badge)
Vue.use(Slider)
Vue.use(Form)
Vue.use(Tooltip)
Vue.use(Select)
Vue.use(Tag)
Vue.use(Affix)
Vue.use(Spin)
Vue.use(Alert)
Vue.use(Checkbox)
Vue.use(Tabs)
Vue.use(Pagination)
Vue.use(Upload)
Vue.use(Message)

Vue.use(Steps)
Vue.use(InputNumber)
Vue.use(Drawer)
Vue.use(Switch)
Vue.use(Cascader)
Vue.use(DatePicker)
Vue.use(TimePicker)
Vue.use(Anchor)
Vue.use(AutoComplete)
Vue.use(Collapse)
Vue.use(BackTop)
Vue.use(ConfigProvider)
Vue.use(Comment)
Vue.use(VueCalendarHeatmap)
Vue.use(Descriptions)
Vue.use(PageHeader)

// Vue.prototype.$notification = notification
// Vue.prototype.$message = message

Vue.use(NProgress)
// Vue.use(FirebaseAuthService)
Vue.use(VuePageTitle, {
	prefix: 'Mercurio Social | ',
	router,
})

Vue.config.productionTip = false
const nprogress = new NProgress({ parent: 'body' })

new Vue({
	router,
	store,
	nprogress,
	i18n,
	render: h => h(App),
}).$mount('#app')
